import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'sheba-loader',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'contents'
  }
})
export class LoaderComponent {
  options: AnimationOptions = {
    path: '/assets/loader/Sheba Bot AI_opt.json',
  };
}
